import { FormDialogConfig } from '@aibees/shared/components';
import * as Yup from 'yup';

export const scheme = Yup.object().shape({
  owner: Yup.string(),
  overwriteOwner: Yup.boolean(),
  selectOwner: Yup.boolean(),
});

export const config: FormDialogConfig = {
  title: 'Save Records (10,000) / Create New Label',
  icon: 'save',
  submitButtonProps: {
    children: 'Create',
  },
  closeButton: {
    children: 'Cancel',
  },

  scheme,
  defaultValues: {
    overwriteOwner: true,
    selectOwner: true,
  },
};
